import { NAME } from './constants';
import { router } from './router';
import * as constants from './constants';

export const Zaloha = {
	name: NAME,
	router,
	constants,
};
